<template>
    <div>
        <Echart :options="options" id="bottomLeftChartotherChart" height="480px" width="100%"></Echart>
    </div>
</template>

<script>
    import request from '@/utils/request';
    import Echart from '@/common/echart'; // eslint-disable-line no-unused-vars
    export default {
        data() {
            return {
                options: {
                    dataZoom: [{
                        type: 'slider',//给x轴设置滚动条
                        show: true, //flase直接隐藏图形
                        xAxisIndex: [0],
                        bottom: 0,
                        height: 20,
                        showDetail: true,
                        startValue: 0,//滚动条的起始位置
                        endValue: 20 //滚动条的截止位置（按比例分割你的柱状图x轴长度）
                    },
                        {
                            type: 'inside',//设置鼠标滚轮缩放
                            show: true,
                            xAxisIndex: [0],
                            startValue: 0,
                            endValue: 20
                        }],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { // 坐标轴指示器，坐标轴触发有效
                            type: 'line'// 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: ['三高', '慢阻肺'],
                        axisLabel: {
                            interval: 0, //强制文字产生间隔
                            rotate: 45,
                            // rotate: 45,
                            textStyle: {
                                fontSize: '10',
                                // fontSize:'8',
                            }
                        }
                    },
                    yAxis: {
                        type: 'value'
                    },
                    grid: {
                        x: 30, //控制x轴文字与底部的距离
                        y2: 80 // y2可以控制倾斜的文字狱最右边的距离，放置倾斜的文字超过显示区域
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        barMaxWidth: '10',
                    }]
                }
            };
        },
        components: {
            Echart
        },
        created() {
            let area = this.$route.query.area;
            let code = this.$route.query.code;
            let level = this.$route.query.level;
            var data = {}
            if (level == '2') {
                data = {area: area}
            } else {
                data = {code: code}
            }
            request({
                url: this.$root.api + `/api/dbz/daping/getSxzzrsByAreaOrCode`,
                method: 'get',
                data: data
            }).then(res => {
                console.log('dpdbzsxzzrs---', res)
                // this.options.series[0].data = res.data
                //   this.options.xAxis.data=['三高','慢阻肺','糖尿病肾病','眩晕综合征','偏头痛','急性气管炎','慢性肺源性心脏病','慢性肺源性心脏病','慢性肺源性心脏病']
                //   this.options.series[0].data=[40,20,20,15,16,10,9,9,9]
                this.options.xAxis.data = res.data.nameList
                this.options.series[0].data = res.data.valueList
            })
        }
    };
</script>

<style></style>
